import { render, staticRenderFns } from "./consignorResourcesCarAccount.vue?vue&type=template&id=317252b6&scoped=true&"
import script from "./consignorResourcesCarAccount.vue?vue&type=script&lang=js&"
export * from "./consignorResourcesCarAccount.vue?vue&type=script&lang=js&"
import style0 from "./consignorResourcesCarAccount.vue?vue&type=style&index=0&id=317252b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317252b6",
  null
  
)

export default component.exports